import { createStore } from '@xstate/store';

/**
 * Fire-and-forget signal asking the periodic local file-scan to run an
 * iteration immediately instead of waiting for its interval. The nonce bump
 * makes each request a distinct snapshot so the provider's subscription
 * re-fires. Used at appointment completion to re-push files the server reports
 * as still-uploading (`missingFiles`) without waiting up to a full scan
 * interval. [ENG-4717]
 */
export const fileSyncTriggerStore = createStore({
  context: { scanRequestedNonce: 0 },
  on: {
    requestScan: (context) => ({
      scanRequestedNonce: context.scanRequestedNonce + 1,
    }),
  },
});
